import { trashTypeSchema, type TrashType } from '@fuel-system/contracts';
import { createFileRoute } from '@tanstack/react-router';
import { RequireService } from '@/components/shared/require-service';
import { TrashPage as TrashPageContent } from '@/features/trash/trash-page';

const TRASH_TYPES = trashTypeSchema.options;
const DEFAULT_TYPE: TrashType = TRASH_TYPES[0] ?? 'DEBTOR';

interface TrashSearch {
  type: TrashType;
  page: number;
}

function isTrashType(value: unknown): value is TrashType {
  return typeof value === 'string' && (TRASH_TYPES as readonly string[]).includes(value);
}

function TrashPage() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <RequireService service="TRASH_LIST">
      <TrashPageContent
        type={search.type}
        page={search.page}
        onTypeChange={(type) => void navigate({ search: { type, page: 1 } })}
        onPageChange={(page) => void navigate({ search: (prev) => ({ ...prev, page }) })}
      />
    </RequireService>
  );
}

/**
 * fuel.md section 5.7: "A type select ... in the URL, paginated" — the type
 * and page live in the route's own search params, so a link to a specific
 * type/page is shareable and survives a reload.
 */
export const Route = createFileRoute('/_app/trash')({
  validateSearch: (search: Record<string, unknown>): TrashSearch => ({
    type: isTrashType(search['type']) ? search['type'] : DEFAULT_TYPE,
    page: Number(search['page']) > 0 ? Number(search['page']) : 1,
  }),
  component: TrashPage,
});
